import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card relative z-10 overflow-hidden shadow-lg border border-gray-200/50 dark:border-gray-700/50" }
const _hoisted_2 = { class: "hidden lg:block" }
const _hoisted_3 = { class: "w-full divide-y divide-gray-200/50 dark:divide-gray-700/50 text-slate-700 dark:text-slate-300 table-fixed" }
const _hoisted_4 = { class: "bg-white dark:bg-gray-900/50 divide-y divide-gray-200/50 dark:divide-gray-700/50" }
const _hoisted_5 = {
  key: 0,
  class: "lg:hidden flex justify-center py-16"
}
const _hoisted_6 = {
  key: 1,
  class: "lg:hidden divide-y divide-gray-200/50 dark:divide-gray-700/50"
}
const _hoisted_7 = {
  key: 2,
  class: "text-center py-16 px-4"
}
const _hoisted_8 = { class: "inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 mb-4" }

import { computed } from 'vue'
import { Users, Loader2 } from 'lucide-vue-next'
import type { Employee } from '@/services/employeeService'
import EmployeeRow from './EmployeeRow.vue'
import EmployeeCard from './EmployeeCard.vue'
import TableLoader from '@/components/ui/TableLoader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeTable',
  props: {
    employees: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const safeEmployees = computed(() =>
  (props.employees ?? []).filter((e): e is Employee => !!e && typeof (e as any).id === 'number')
)

// const emit = defineEmits<{
// 	(e: 'view', id: number): void
// 	(e: 'activate', id: number): void
// 	(e: 'deactivate', id: number): void
// 	(e: 'approve', id: number): void
// 	(e: 'delete', id: number): void
// }>()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "bg-gradient-to-r from-primary/5 via-primary/3 to-transparent dark:from-primary-dark/10 dark:via-primary-dark/5 dark:to-transparent" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              scope: "col",
              class: "px-4 xl:px-6 py-4 text-left text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-32"
            }, " Name "),
            _createElementVNode("th", {
              scope: "col",
              class: "hidden xl:table-cell px-4 xl:px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-32"
            }, " Phone "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-4 xl:px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-32"
            }, " Status "),
            _createElementVNode("th", {
              scope: "col",
              class: "hidden xl:table-cell px-4 xl:px-6 py-4 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-36"
            }, " Last Updated "),
            _createElementVNode("th", {
              scope: "col",
              class: "px-4 xl:px-6 py-4 text-center text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider w-40"
            }, " Actions ")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_4, [
          (__props.loading)
            ? (_openBlock(), _createBlock(TableLoader, {
                key: 0,
                colspan: 5,
                title: "Fetching Employees"
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(safeEmployees.value, (employee) => {
                return (_openBlock(), _createBlock(EmployeeRow, {
                  key: employee.id,
                  employee: employee,
                  onView: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view', $event))),
                  onActivate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('activate', $event))),
                  onDeactivate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('deactivate', $event))),
                  onApprove: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('approve', $event))),
                  onDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('delete', $event)))
                }, null, 8, ["employee"]))
              }), 128))
        ])
      ])
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(Loader2), { class: "h-8 w-8 animate-spin text-primary" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(safeEmployees.value, (employee) => {
            return (_openBlock(), _createBlock(EmployeeCard, {
              key: employee.id,
              employee: employee,
              onView: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('view', $event))),
              onActivate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('activate', $event))),
              onDeactivate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('deactivate', $event))),
              onApprove: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('approve', $event))),
              onDelete: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('delete', $event)))
            }, null, 8, ["employee"]))
          }), 128))
        ])),
    (!__props.loading && safeEmployees.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Users), { class: "w-8 h-8 text-secondary-text/50 dark:text-secondary-dark-text/50" })
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-base font-medium text-secondary-text dark:text-secondary-dark-text" }, " No employees found ", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-sm text-secondary-text/70 dark:text-secondary-dark-text/70 mt-1" }, " Try adjusting your search or filters ", -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})